import { render, staticRenderFns } from "./platformTC.vue?vue&type=template&id=3851cf7e&scoped=true&"
import script from "./platformTC.vue?vue&type=script&lang=js&"
export * from "./platformTC.vue?vue&type=script&lang=js&"
import style0 from "./platformTC.vue?vue&type=style&index=0&id=3851cf7e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3851cf7e",
  null
  
)

export default component.exports